export const REDUX_PAY = {
    LOADING: "PAY_LOADING",
    RUN_KYC: "RUN_KYC",
    TRANSACTION: "TRANSACTION"
}

export interface ISettingsState {
  loading: boolean;
  kycToRun: any
  transaction: any
}

const initialState: ISettingsState = {
  loading: false,
  kycToRun: {},
  transaction: {}
};

export default function reducer(state = initialState, action: any) {
  switch (action.type) {
    case REDUX_PAY.LOADING: {
        return {...state, loading: action.payload}
    }
    case REDUX_PAY.RUN_KYC: {
        return {...state, kycToRun: action.payload}
    }
    case REDUX_PAY.TRANSACTION: {
        return {...state, transaction: action.payload}
    }
    default: {
      return state;
    }
  }
}